// 1. React and core dependencies
import React, { useState, useEffect } from 'react';

// 2. UI Components
import { Modal, Button, Form, Row, Col, Card } from 'react-bootstrap';

// 3. Components
import LoadingDots from 'components/loading/LoadingRed';
import ButtonRequest from 'components/buttons/ButtonRequest';
import InputTextFetchData from 'components/form-elements/InputTextFetchData';
import { ToastSuccess, ToastErrorApi, ToastErrorCath } from 'components/alerts/toast';
// 4. utils
import formatMoney from 'utils/formatMoney';

// 5. API calls
import { addOverweight, calculateOverweight, getAdminDetailShipping } from '../../../api/Api-admin';

const OverweightModal = ({ isModalOpen, setIsModalOpen, setUpdatePage }) => {
  const initialValues = {
    id: '',
    serviceName: '',
    userName: '',
    depth: '',
    width: '',
    height: '',
    weight: '',
    volumetricWeight: '',
    totalWeight: '',
    realWeight: '',
    weightDiff: '',
    overweight: {},
  };
  const [shipping, setShipping] = useState(initialValues);
  const [isCalculateOverweight, setIsCalculateOverweight] = useState(false);
  const [isGettingData, setIsGettingData] = useState(false);
  const [requestErrResponse, setRequestErrResponse] = useState('');
  const [isShippingOk, setIsShippingOk] = useState(false);
  const [overweightCharges, setOverweightCharges] = useState(null); // AQUI SE GUARDA LA RESPUESTA DEL CALCULO DE SOBREPESO
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isAddChargerLoader, setIsAddChargerLoader] = useState(false);

  // - Data Validation
  const updateField = (data, validation, field) => {
    // Eliminar espacios y caracteres especiales
    const cleanedData = data.replace(/[^a-zA-Z0-9 ]/g, '').trim();
    if (validation.test(cleanedData)) {
      setShipping({
        ...shipping,
        [field]: cleanedData,
      });
    } else {
      setShipping({
        ...shipping,
        [field]: '', // Limpiar el valor si no pasa la validación
      });
    }
  };
  const closeModal = () => {
    // Reset to initial values
    setShipping(initialValues);
    setIsModalOpen(false);
    setRequestErrResponse('');
    setIsShippingOk(false);
    setOverweightCharges(null);
  };
  const closeModalAndRenderData = () => {
    closeModal();
    setUpdatePage(true);
  };
  // - Form autofill
  const getShippingData = async (e) => {
    const inputValue = e.target.value;
    const cleanedInputValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '').trim();
    const key = e.nativeEvent.inputType;
    setIsGettingData(true);
    // console.log('valores antes de actualizar', pickup);
    // If the user is deleting
    if (key === 'deleteContentBackward' || key === 'deleteContentForward') {
      setIsGettingData(false);
      return;
    }
    try {
      if (inputValue.length > 5) {
        const response = await getAdminDetailShipping(cleanedInputValue);
        // console.log('getAdminDetailShipping response:', response);
        if (response.shipping_code !== undefined) {
          setIsButtonDisabled(false);
          setIsShippingOk(true); // to show div data
          // Set states with data from firebase Start
          setShipping({
            ...shipping,
            id: cleanedInputValue,
            serviceName: response.shipping_code,
            userName: response.razon_social,
            depth: response.parcel.depth,
            width: response.parcel.width,
            height: response.parcel.height,
            weight: response.parcel.weight,
            volumetricWeight: response.parcel.volumetric_weight,
            totalWeight: response.parcel.total_weight,
            overweight: response.shipping_overweights[0],
          });
        } else if (response.error) {
          setIsShippingOk(false);
          const firstKey = Object.keys(response.error)[0];
          ToastErrorApi(response.error[firstKey]);
          // handleRequestError(response.data.error.admin[0]);
          setShipping({
            ...shipping,
            id: cleanedInputValue,
            serviceName: '',
            userName: '',
            depth: '',
            width: '',
            height: '',
            weight: '',
            volumetricWeight: '',
            totalWeight: '',
            overweight: '',
          });
        }
      }
    } catch {
      ToastErrorCath();
    } finally {
      setIsGettingData(false);
    }
  };
  const handleCalculateOverweight = async () => {
    if (!shipping.id) {
      setRequestErrResponse('* Ingresa el ID de envío');
      return;
    }
    if (!shipping.weightDiff && !shipping.realWeight) {
      setRequestErrResponse('* Ingresa la diferencia de peso o el peso real para calcular el sobrepeso');
      return;
    }
    try {
      setIsCalculateOverweight(true);
      const response = await calculateOverweight(shipping.id, shipping.weightDiff, shipping.realWeight);
      // console.log('calculate overweight res:', response);
      if (response.overweight_charge_info !== undefined) {
        setOverweightCharges(response.overweight_charge_info);
      } else if (response.error) {
        setOverweightCharges(null);
        setRequestErrResponse(response?.error?.admin);
      }
    } catch {
      ToastErrorCath(); // PORQUE CAE AQUI?
    } finally {
      setIsCalculateOverweight(false); // Esto siempre se ejecuta al final
    }
  };

  const handlerAddOverweight = async () => {
    setIsAddChargerLoader(true); // active loader in the button

    if (!shipping.id) {
      setRequestErrResponse('* Ingresa el id de envio');
      return;
    }
    if (!shipping.weightDiff && !shipping.realWeight) {
      setRequestErrResponse('* Ingresa la diferencia de peso o el peso real para calcular el sobrepeso');
      return;
    }
    try {
      const response = await addOverweight(shipping.id, shipping.weightDiff, shipping.realWeight);
      // console.log('add overweight res:', response);
      if (response.overweight_charge !== undefined) {
        // ToastSuccess('Se agrego sobrepeso correctamente');
        ToastSuccess(`⭐ Sobrepeso agregado correctamente. Monto: $${response?.overweight_charge} Envío: ${response.shipping_id}`);

        closeModalAndRenderData();
      } else if (response.error) {
        const firstKey = Object.keys(response.error)[0];
        ToastErrorApi(response.error[firstKey]);
      }
    } catch {
      ToastErrorCath();
    } finally {
      setIsAddChargerLoader(false); // active loader in the button
    }
  };

  useEffect(() => {
    if (shipping?.id?.length === 0) {
      setIsShippingOk(false);
      // Reset to initial values
      setShipping(initialValues);
    }
  }, [shipping?.id]);
  return (
    <Modal show={isModalOpen} onHide={() => closeModal()}>
      <Modal.Header closeButton>
        <Modal.Title className="text-primary">Sobrepeso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          onClick={() => {
            setRequestErrResponse('');
          }}
        >
          <InputTextFetchData
            label="1. Introduce el ID del envío para verificar los datos de la guía."
            icon="shipping"
            maxLength=""
            placeholder="ID Envío"
            value={shipping.id}
            isRequired="false"
            // isError={isRequestError}
            // error={requestError}
            setValues={getShippingData}
            isLoading={isGettingData}
            fieldName="id"
            validation={/^[A-Z0-9 ]+$/i}
            setField={updateField}
            // cleanError={cleanError}
          />

          <Form.Label>2. Calcula si aplica sobrepeso y revisa el costo antes de cobrar.</Form.Label>
          <div className="d-flex flex-wrap">
            <Form.Control
              type="text"
              style={{ fontFamily: 'Montserrat' }}
              className="mb-2 w-50"
              placeholder="Peso real"
              value={shipping.realWeight}
              onChange={(e) => updateField(e.target.value, /^[0-9]+$/i, 'realWeight')}
            />
            <div className="mb-2 w-50 ps-2">
              <Form.Control
                type="text"
                style={{ fontFamily: 'Montserrat' }}
                placeholder="Diferencia de peso"
                value={shipping.weightDiff}
                onChange={(e) => updateField(e.target.value, /^[0-9]+$/i, 'weightDiff')}
              />
            </div>
          </div>
        </div>
        <ButtonRequest
          title="Calcular sobrepeso"
          titleLoading="Calcular sobrepeso"
          handlerFn={handleCalculateOverweight}
          isButtonDisabled={isCalculateOverweight}
          isLoading={isCalculateOverweight}
        />
        <div className={`mt-2 text-secondary ${requestErrResponse ? 'visible' : 'invisible'}`}>{requestErrResponse}</div>
        <Card className={`mt-3 p-0 m-0 ${isShippingOk ? 'd-flex' : 'd-none'}`}>
          <Card.Body>
            <div className="d-flex flex-wrap">
              <span className="mb-4 w-sm-60 pe-4">
                <p className="text-small text-muted mb-2 ">ENVÍO</p>
                <div className="text-alternate">{shipping?.userName.toUpperCase()}</div>
                <div className="text-alternate">{`${shipping?.serviceName}`}</div>
                {/* <div className="text-alternate">{`ID: ${shipping?.id}`}</div> */}
              </span>
              <span className="w-sm-40 ">
                <p className="text-small text-muted mb-2">PESO</p>
                <div className="text-muted">
                  <span className="text-medium text-alternate text-uppercase"> Físico:</span>
                  <strong className="text-muted"> {`${shipping?.weight} kg`}</strong>
                </div>
                <div className="text-primary">
                  <span className="text-medium text-alternate text-uppercase"> Volumétrico:</span>
                  <strong className="text-muted"> {`${shipping?.volumetricWeight} kg`}</strong>
                </div>
                <div className="text-primary">
                  <span className="text-medium text-alternate text-uppercase"> Cobrado:</span>
                  <strong className="text-muted"> {`${shipping?.totalWeight} kg`}</strong>
                </div>
              </span>

              {overweightCharges && (
                <div className="mt-3 w-100">
                  <p className="text-small text-muted mb-1">SOBREPESO</p>
                  <Row>
                    <Col xs="6" className="text-alternate text-uppercase">
                      <div>Kilos Amparados:</div>
                    </Col>
                    <Col xs="6" className="d-flex align-items-end">
                      <strong className="text-muted">{overweightCharges?.kg_coverage_for_shipping}</strong>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="6" className="text-alternate text-uppercase">
                      <div>Peso Real:</div>
                    </Col>
                    <Col xs="6" className="d-flex align-items-end">
                      <strong className="text-muted">{overweightCharges?.real_weight}</strong>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="6" className="text-alternate text-uppercase">
                      <div>Kilos a Cobrar:</div>
                    </Col>
                    <Col xs="6" className="d-flex align-items-end">
                      <strong className="text-muted">{overweightCharges?.kg_to_collect}</strong>
                    </Col>
                  </Row>
                  {/* <hr className="my-1" /> */}
                  <Row>
                    <Col xs="6" className="text-alternate text-uppercase">
                      <div>Sobrepeso:</div>
                    </Col>
                    <Col xs="6" className="d-flex align-items-end">
                      <strong className="text-alternate">{` $${formatMoney(overweightCharges?.extra_kg_cost)}`}</strong>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="6" className="text-alternate text-uppercase">
                      <div>Sobrepeso + IVA:</div>
                    </Col>
                    <Col xs="6" className="d-flex align-items-end">
                      <strong className="text-primary">{` $${formatMoney(overweightCharges?.overweight_charge_with_iva)}`}</strong>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end">
          <Button
            variant="outline-primary"
            onClick={() => {
              setIsModalOpen(false);
              closeModal();
            }}
            style={{ height: '36px' }}
            className="me-2"
          >
            Cancelar
          </Button>
          <ButtonRequest
            title="Cobrar"
            titleLoading="Cobrar"
            handlerFn={handlerAddOverweight}
            isButtonDisabled={isButtonDisabled}
            isLoading={isAddChargerLoader}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default OverweightModal;
